import { useState } from "react";
import { useAuth } from "../auth/AuthContext";
import { LoginForm } from "./LoginForm";
import { RecoveryForm } from "./RecoveryForm";
import { RegisterForm } from "./RegisterForm";

export function AuthPage() {
  const { problem, refresh, logout } = useAuth();
  const [mode, setMode] = useState<"login" | "register" | "recovery">("login");
  const revoked = problem?.kind === "revoked";

  return (
    <div className="relative min-h-screen flex items-center justify-center p-6 overflow-hidden">
      <img
        src="/images/persona-ai-bg.png"
        alt="Persona AI Background"
        className="absolute inset-0 w-full h-full object-contain -z-10"
      />
      <div className="relative w-full max-w-sm rounded-2xl border border-slate-200 bg-white p-6 shadow-lg">

        {problem && (
          <div
            role="alert"
            className={`mt-5 rounded-xl border px-4 py-3 text-sm ${
              revoked
                ? "border-rose-200 bg-rose-50 text-rose-800"
                : "border-amber-200 bg-amber-50 text-amber-800"
            }`}
          >
            <p className="font-semibold">
              {revoked ? "Access revoked" : "Server unavailable"}
            </p>
            <p className="mt-1">{problem.message}</p>
          </div>
        )}

        {revoked ? (
          // The Kratos session is still valid, so a fresh sign-in would loop
          // straight back here. Clearing it is the only useful action.
          <div className="mt-6">
            <button
              type="button"
              onClick={() => void logout()}
              className="w-full rounded-xl bg-brand-navy px-4 py-3 text-sm font-semibold text-white"
            >
              Sign out of this account
            </button>
          </div>
        ) : mode === "register" ? (
          <RegisterForm onBackToLogin={() => setMode("login")} />
        ) : mode === "recovery" ? (
          <RecoveryForm onBackToLogin={() => setMode("login")} />
        ) : (
          <>
            <LoginForm onForgotPassword={() => setMode("recovery")} />

            <div className="mt-6 border-t border-slate-200 pt-5">
              <p className="text-sm text-slate-600">
                Do not have an account yet?{" "}
                <button
                  type="button"
                  onClick={() => setMode("register")}
                  className="font-semibold text-brand-navy hover:underline"
                >
                  Register
                </button>
              </p>
            </div>
          </>
        )}

        {problem?.kind === "unreachable" && (
          <button
            type="button"
            onClick={() => void refresh()}
            className="mt-4 w-full rounded-xl border border-slate-300 px-4 py-3 text-sm font-semibold text-slate-800"
          >
            Retry
          </button>
        )}

        <div className="mt-8 border-t border-slate-200 pt-4 text-center">
          <p className="text-xs text-slate-500">
            Powered by <span className="font-semibold">HID identity ORY</span>
          </p>
        </div>
      </div>
    </div>
  );
}
